import { render, staticRenderFns } from "./TestRegistrationPage.vue?vue&type=template&id=0e8b9151"
import script from "./TestRegistrationPage.vue?vue&type=script&lang=js"
export * from "./TestRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports